export const CashRegisterIcon = ({ className, size = 20 }) => (
  <img
    src="/favicon.svg"
    className={`w-${size / 4} h-${size / 4} ${className}`}
    alt="Cash Register"
  />
);
